import {ReviewRatingTypeEnum, ReviewSortingTypeEnum} from '../../../../service/reviews/reviews-type';
import {
    AutoAbuseEnum,
    ContentOfReviewsEnum,
    DeletedReviewsEnum,
    HasNotesEnum,
    HiddenReviewsEnum,
    ModeratedEnum,
    PossibilityOfAnAnswerEnum,
    RepliesToReviewsEnum,
    ReplyPublishedEnum,
    ReviewChangedEnum,
    ReviewNameEnum,
    ReviewsFilterFieldNameEnum,
    WaitingForSecondAnswerEnum,
    WithoutTagEnum,
} from '../review-list-page-content/reviews-filter/reviews-filter-type';

import {ReviewsStateType, ReviewsStateUrlQueryNameEnum} from './reviews-state-type';

export const defaultReviewsState: ReviewsStateType = {
    [ReviewsStateUrlQueryNameEnum.ratingType]: ReviewRatingTypeEnum.allRating,
    [ReviewsStateUrlQueryNameEnum.ids]: '',
    [ReviewsStateUrlQueryNameEnum.companyIds]: '',
    [ReviewsStateUrlQueryNameEnum.search]: '',
    filterState: {
        [ReviewsFilterFieldNameEnum.brandIds]: null,
        [ReviewsFilterFieldNameEnum.sourceList]: [],
        [ReviewsFilterFieldNameEnum.processStatus]: [],
        [ReviewsFilterFieldNameEnum.customProcessStatus]: [],
        [ReviewsFilterFieldNameEnum.ratingList]: [],
        [ReviewsFilterFieldNameEnum.employeesResponding]: [],
        [ReviewsFilterFieldNameEnum.employeesResponsible]: [],
        [ReviewsFilterFieldNameEnum.doctorNames]: [],
        [ReviewsFilterFieldNameEnum.tagList]: [],
        [ReviewsFilterFieldNameEnum.withoutTag]: WithoutTagEnum.noSelected,
        [ReviewsFilterFieldNameEnum.hasNotes]: HasNotesEnum.noSelected,
        [ReviewsFilterFieldNameEnum.hiddenReviews]: HiddenReviewsEnum.noSelected,

        [ReviewsFilterFieldNameEnum.autoReplay]: [],
        [ReviewsFilterFieldNameEnum.contentOfReviews]: ContentOfReviewsEnum.noSelected,
        [ReviewsFilterFieldNameEnum.deletedReviews]: DeletedReviewsEnum.noSelected,
        [ReviewsFilterFieldNameEnum.repliesToReviews]: RepliesToReviewsEnum.noSelected,
        [ReviewsFilterFieldNameEnum.possibilityOfAnAnswer]: PossibilityOfAnAnswerEnum.noSelected,
        [ReviewsFilterFieldNameEnum.reviewType]: ReviewNameEnum.noSelected,
        [ReviewsFilterFieldNameEnum.abuseStatus]: [],
        [ReviewsFilterFieldNameEnum.autoAbuse]: AutoAbuseEnum.notSelected,
        [ReviewsFilterFieldNameEnum.reviewChanged]: ReviewChangedEnum.noSelected,
        [ReviewsFilterFieldNameEnum.waitingForSecondAnswer]: WaitingForSecondAnswerEnum.noSelected,
        [ReviewsFilterFieldNameEnum.reviewModerated]: ModeratedEnum.noSelected,
        [ReviewsFilterFieldNameEnum.replyPublished]: ReplyPublishedEnum.noSelected,

        [ReviewsFilterFieldNameEnum.dateFrom]: null,
        [ReviewsFilterFieldNameEnum.dateTo]: null,
        [ReviewsFilterFieldNameEnum.collectionDateFrom]: null,
        [ReviewsFilterFieldNameEnum.collectionDateTo]: null,
        [ReviewsFilterFieldNameEnum.replyDateFrom]: null,
        [ReviewsFilterFieldNameEnum.replyDateTo]: null,
        [ReviewsFilterFieldNameEnum.agencyRepliers]: [],
    },
    filterId: '',
    [ReviewsStateUrlQueryNameEnum.sorting]: ReviewSortingTypeEnum.acs,
};
